module.exports = __webpack_public_path__ + "img/valance-whale-tail.40c06173.jpg";